import { render, staticRenderFns } from "./WebhookAutomodal.vue?vue&type=template&id=56c24d98&"
import script from "./WebhookAutomodal.vue?vue&type=script&lang=js&"
export * from "./WebhookAutomodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports